let host, api_url

host = 'http://localhost:8080',
console.log(window.location, 9988, 999)
if (window.location.host != 'track.freightcloud.net') { // develop1
  // 测试环境 https://truckapi.f.yizuo.ltd
  // 擎阳本地 http://192.168.0.8:5000
  host = 'https://tw.f.yizuo.ltd',
  api_url = 'https://truckapi.f.yizuo.ltd'

}

if (window.location.host == 'air.yizuo.ltd') { // 
  host = 'https://air.yizuo.ltd',
  api_url = 'https://airapi.yizuo.ltd'
}

export let HOST = host
export let API_URL = api_url



// WEBPACK FOOTER //
// ./src/baseurl.js